import http from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'userpreferences/v1/emails';
export default class EmailsAPI {
  static get() {
    return http.get(API_BASE);
  }
  static add(email) {
    return http.post(`${API_BASE}/${email}`);
  }
  static remove(id) {
    return http.delete(`${API_BASE}/${id}`);
  }
  static resendVerification(id) {
    return http.post(`${API_BASE}/${id}/verify/resend`);
  }
  static setPrimary(id) {
    return http.post(`${API_BASE}/${id}/primary`);
  }
}